(function() {
  angular.module('forgotPassword')
  .controller('resetPasswordController', ['$scope','$log','$state', 'resetPasswordFactory', 'ResetEmail','$translate',
  function($scope, $log, $state, resetPasswordFactory, ResetEmail, $translate) {
    var vm = this;
    vm.submit = submit;
    vm.reset = reset;
    vm.model = {};
    vm.passwordException = false;
    $scope.successText = undefined;
    vm.stateParams = $state.params;
    vm.model.password=undefined;
    resetPasswordFactory.get({'id': vm.stateParams.id, 'guid':vm.stateParams.guid}, function(data) {
      vm.firstName = data.firstName;
      vm.lastName = data.lastName;
      vm.serverUserid = data.userId;
    }, function(rejection) {
      if (rejection === 'invalidPasswordResetLink') {
        $scope.dnConfirmationMessage.$show('This password reset link is invalid.', 'danger').then(() => {
          $state.go('root');
        });
      }
    });


    function submit(){
    	vm.passwordException = false;
      $scope.errorControl.showErrors();
      if ($scope.resetPasswordForm.$valid) {
        var userData = {
          password : vm.model.password,
          userId: vm.model.userId
        };

        ResetEmail(vm.stateParams.guid).reset(userData, function(data) {
          $scope.dnConfirmationMessage.$show("Password Reset Successful").then(() => {
            $state.go('root');
          });
        },function(rejection) {
            if (rejection.status == 400 && rejection.headers("x-http-password-reset-status") == "Password in history." ) {
            	vm.passwordException = true;
            }else{
            	vm.passwordException = false;
            }
        });
      }
    }

    function reset() {
      $scope.errorControl.hideErrors();
      $scope.errorMessage = '';
      vm.passwordException = false;
      vm.model = {};
    }
  }]);
})();
